import { startOfToday } from 'date-fns';

import {
  STEPS,
  BRANDS,
  SEARCH,
  SENDER_FILTER_MODE,
  STATUS,
  AUTHORS,
  MODULES,
  NOT_EXIST,
  SELECTED_DATE,
  ASSIGNEE_USERS,
  KANBAN_ACTIONS,
  ASSIGNEE_USER_GROUPS,
  ADVISOR_USERS,
  ADVISOR_USER_GROUPS,
  TAGS,
  ANY_SENDERS,
  CHECK_IN_SENDERS,
  CHECK_OUT_SENDERS
} from 'constants/FilterConstants';
import { STATUSES } from 'constants/InterventionConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';

import * as types from 'modules/interventions/actionTypes';

import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

const persistedFilters = getPersistedFilters()?.filters?.kanban ?? {};

/** @typedef {'selectedDate' | 'status' | 'modules' | 'stepIds' | 'text' | 'senders' | 'brands' | 'assignedUserGroupIds' | 'assignedUserIds' | 'authors'} FilterField */

/** @typedef {Record<FilterField, string | number | Array<string> | Array<number>>} KanbanFiltersReducer */

/** @type {KanbanFiltersReducer} */
const emptyState = {
  [STEPS]: [],
  [BRANDS]: [],
  [TAGS]: [],
  [AUTHORS]: [],
  [CHECK_IN_SENDERS]: [],
  [CHECK_OUT_SENDERS]: [],
  [ANY_SENDERS]: [],
  senderFilterMode: SENDER_FILTER_MODE.EXACT,
  [MODULES]: [],
  [SEARCH]: null,
  [NOT_EXIST]: [],
  [ASSIGNEE_USERS]: [],
  [ASSIGNEE_USER_GROUPS]: [],
  [ADVISOR_USERS]: [],
  [ADVISOR_USER_GROUPS]: [],
  [KANBAN_ACTIONS]: [],
  [SELECTED_DATE]: startOfToday().toISOString(), // This is incorrect due to timezone, should be fixed by the saga
  [STATUS]: [STATUSES.OPEN, STATUSES.TO_BE_SENT, STATUSES.SENT, STATUSES.READ, STATUSES.ANSWERED],
};

/** @type {FilterAdapter<KanbanFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, {
  ...persistedFilters,
  ...(persistedFilters?.[STATUS] && {
    [STATUS]: persistedFilters[STATUS].filter(status => status !== STATUSES.IN_PROGRESS),
  }),
});

export const initialState = filterAdapter.getInitialState();

const setSenderFilterMode = (state, action) => ({
  ...state,
  senderFilterMode: action.payload,
});

export default createReducer(initialState, {
  [types.SET_KANBAN_INTERVENTION_FILTER]: filterAdapter.setFilter,
  [types.SET_KANBAN_SENDER_FILTER_MODE]: setSenderFilterMode,
  [types.SET_KANBAN_INTERVENTION_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_KANBAN_INTERVENTION_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_KANBAN_INTERVENTION_FILTER]: filterAdapter.removeFilter,
});
